import * as React from 'react'
import { QuestionCard } from '../../atoms/question-card/question-card'
import { FrequentlyQuestionsInfo } from './frequently-questions-info'
import './frequently-questions.scss'

export const FrequentlyQuestions = () => {
  const questionsToShowMore = 4
  const [questionsToShow, setQuestionsToShow] = React.useState(8)

  const handleShowMore = () => {
    setQuestionsToShow(actualValue => actualValue + questionsToShowMore)
  }

  return (
    <section className="f-questions" id="preguntas-frecuentes">
      <h2 className="f-questions__title">PREGUNTAS FRECUENTES</h2>

      <div className="f-questions__list-questions">
        {FrequentlyQuestionsInfo.slice(0, questionsToShow)?.map(
          ({ title, description }, index) => {
            return (
              <QuestionCard
                key={index}
                title={title}
                description={description}
              />
            )
          }
        )}
      </div>

      {questionsToShow < FrequentlyQuestionsInfo.length && (
        <button
          onClick={() => {
            window.dataLayer.push({
              event: 'Interacciones - Cargar mas',
              category: 'cole challenge',
              action: 'click',
              label: 'cargar mas',
            })
            handleShowMore()
          }}
          className="f-questions__show-more"
        >
          Cargar más
        </button>
      )}

      <a
        className="f-questions__terms"
        href="#terminos-y-condiciones"
        onClick={() => {
          window.dataLayer.push({
            event: 'Interacciones - Terminos y Condiciones',
            category: 'cole challenge',
            action: 'click',
            label: 'terminos y condiciones del concurso',
          })
        }}
      >
        Términos y condiciones del concurso
      </a>
    </section>
  )
}
